(function (angular, schoolwork12) {
    'use strict';

    angular.module(schoolwork12.app.studentview.name)
        .controller(schoolwork12.app.studentview.controllers.studentGradPlanView, ['$rootScope', '$scope', '$http', '$location', '$timeout', schoolwork12.app.auth.services.authentication,
          schoolwork12.app.common.services.eventNotification, 'graduationPlanSvc', schoolwork12.app.common.services.utilService,

          function ($rootScope, $scope, $http, $location, $timeout, authentication, eventNotification, graduationPlanSvc, utilService) {
                console.info('calling student grad plan Controller:......');
                $scope.stuGradPlanSuccess = false;
                $scope.gpHeader = {};
                $scope.userName = {};
                $scope.note = {};

                eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                    function (event, authenticatedUser) {
                        console.info('Student view grad plan controller: Subscribe On UserLogin Event: '
                            .concat(angular.toJson(authenticatedUser)));

                        $scope.userName = authenticatedUser.username;
                        $scope.personId = authenticatedUser.personId;
                        $scope.schoolId = authenticatedUser.schoolId;

                        $scope.hasLCRole  = authentication.hasLCRole();
                        $scope.hasStudentRole  = authentication.hasStudentRole();

                    });
                $scope.gradPlanAccordions = { creditViewSummary: true, additionalCourses: true, addRequirements: true, creTracking: true, opened: true };
                $scope.isSpinnerActive = true;

                $scope.bySubjectView = false;
                $scope.byYearView = true;
                $scope.gpViewModel = 'Year';
                $scope.showLegend = false;

                var getStudentsLCList = function(personId, schoolId){
                        //GET saved notes list for student
                        var getStudentsLCListPromise = graduationPlanSvc.getLCStudentsList(authentication.getCurrentUser().keycode, personId, schoolId);
                        getStudentsLCListPromise.then(function (data) {
                           console.info("Providing list of LC Students", data);

                           $scope.stuLCList = data;
                           $rootScope.selStuId = data[0].id;
                           $rootScope.selectedLCStudent = $scope.stuLCList[0];

                        }, function (error) {
                            console.info('Error in getting list of LC Students....'.concat(angular.toJson(error)));
                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        })
                    };

                $scope.viewStudentNote = function(){
                    $scope.hideNoteGP = false;
                    if($scope.noteRead){
                        $scope.hideNoteGP = true;
                    }

                    if(!$scope.hideNoteGP){
                        $rootScope.noteRead = true;
                        console.log("note is read")
                    }
                }

                $scope.toggleSubjectView = function(){
                    $scope.bySubjectView = true;
                    $scope.byYearView = false;
                    $scope.showSavedStudentMsg = false;
                }

                $scope.toggleYearView = function(){
                    $scope.byYearView = true;
                    $scope.bySubjectView = false;
                    $scope.yearViewClicked = true;
                }

                $scope.displayText = function(course){
                        	var text = '';
                        	if(course.tranTermType == "Transfer Credit" || course.tranTermType == "Concurrent Enrollment"){
                        		text += course.tranTermType;
                        	}

                        	if(course.dualCredit == "1"){
                        		if(text.length > 0){
                        			text += ' and ';
                        		}
                        		text += 'Dual Credit';
                        	}
                        	return text;
                };

                $scope.printGradPlan = function() {
                            window.print();
                };

                 $scope.getSavedNotesGP = function(){
                        //GET saved notes list for student
                        var getSavedNotesPromise = graduationPlanSvc.getSavedNotes(authentication.getCurrentUser().keycode, $scope.gpHeader.studentGradPlanId);
                        getSavedNotesPromise.then(function (data) {
                            console.info("Providing list of saved notes for Student");

                            var noteListArr = $scope.noteList = data.noteList;
                            var stuNoteObj = _.find(noteListArr, function (stuNoteObj) { return stuNoteObj.noteTypeId == 3; });

                            $scope.studentNoteObj = stuNoteObj;
                            $scope.note.studentNote = stuNoteObj ? $scope.studentNoteObj.note : '';

                        }, function (error) {
                            console.info('Error in getting saved notes for Student....'.concat(angular.toJson(error)));
                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        })
                    };

                var getStudentGradPlan = function (studentId, schoolId) {
                    var studentIdUpdated = null;
                    var schoolIdUpdated = null;
                    if(typeof(studentId) != 'undefined' && studentId != null ){
                        studentIdUpdated = studentId;
                    }
                    //Need to remove this and handle error
                    /*else {
                        studentIdUpdated = 159492;
                    }*/
                    if(typeof(schoolId) != 'undefined' && schoolId != null ){
                        schoolIdUpdated = schoolId;
                    }
                    //Need to remove this and handle error
                    /*else {
                        schoolIdUpdated = 1020;
                    }*/
                    console.info('Retrieve grad plan for student: ' + studentIdUpdated + ' in school: ' + schoolIdUpdated);
                    if(schoolIdUpdated != null && studentIdUpdated != null){
                        $http({
                            url: schoolwork12.app.student.endpoints.studentEdit + studentIdUpdated + '/gradplan/school/' + schoolIdUpdated,
                            method: "GET",
                            headers: {
                                'X-API-TOKEN': authentication.getCurrentUser().keycode,
                            }
                        }).then(function (response) {
                            console.info("Viewing student graduation plan");
                            $scope.stuGradPlanSuccess = true;
                            $scope.yearDetailList = response.data.studentGradPlan.stdDbGplanYearList;
                            $scope.addCoursesList = response.data.studentGradPlan.additionalCourses;
                            $scope.addRequirementList = response.data.studentGradPlan.addtionalRequirements;
                            $scope.pathwayRequirementsList = response.data.studentGradPlan.creTracking;
                            $scope.gpHeader = {
                                //createDate: response.data.studentGradPlan.createDate,
                                creditsEarned: response.data.studentGradPlan.creditsEarned,
                                creditsEarnedNotCounted: response.data.studentGradPlan.creditsEarnedNotCounted,
                                creditsNeeded: response.data.studentGradPlan.creditsNeeded,
                                creditsNeededToGraduate: response.data.studentGradPlan.creditsNeededToGraduate,
                                creditsRequired: response.data.studentGradPlan.creditsRequired,
                                diplomaId: response.data.studentGradPlan.diplomaId,
                                //diplomaName: response.data.studentGradPlan.diplomaName,
                                //lastModifiedDate: response.data.studentGradPlan.lastModifiedDate,
                                schoolId: response.data.studentGradPlan.schoolId,
                                studentGradPlanId: response.data.studentGradPlan.studentGradPlanId,
                                studentId: response.data.studentGradPlan.studentId,
                                studentCohortYear: response.data.studentGradPlan.studentCohortYear,
                                studentFederalCohortYear : response.data.studentGradPlan.studentFederalCohortYear,
                                gradeLevel : response.data.studentGradPlan.gradeLevel,
                                schoolEnrollDate : new Date(response.data.studentGradPlan.schoolEnrollDate),
                                cteDispName: response.data.studentGradPlan.cteDispName
                                //userName = authenticatedUser.username;
                            }
                            //Map view summary section
                            $scope.creditSummaryFound = false;
                            if (angular.isDefined(response.data.studentGradPlan.creditsEarned) || angular.isDefined(response.data.studentGradPlan.creditsRequired) ||      angular.isDefined(response.data.studentGradPlan.creditsEarnedNotCounted) || angular.isDefined(response.data.studentGradPlan.creditsNeeded)) {
                                $scope.creditSummaryFound = true;
                                $scope.creditsEarned = angular.isDefined(response.data.studentGradPlan.creditsEarned) ? response.data.studentGradPlan.creditsEarned : 0;
                                $scope.creditsRequired = angular.isDefined(response.data.studentGradPlan.creditsRequired) ? response.data.studentGradPlan.creditsRequired : 0;
                                $scope.creditsEarnedNotCounted = angular.isDefined(response.data.studentGradPlan.creditsEarnedNotCounted) ? response.data.studentGradPlan.creditsEarnedNotCounted : 0;
                                $scope.creditsNeeded = angular.isDefined(response.data.studentGradPlan.creditsNeeded) ? response.data.studentGradPlan.creditsNeeded : 0;
                                $scope.creditsNeededToGraduate = angular.isDefined(response.data.studentGradPlan.creditsNeededToGraduate) ? response.data.studentGradPlan.creditsNeededToGraduate : '';
                                $scope.percentageCompleted = calculateProgressBar($scope.creditsEarned, $scope.creditsRequired);
                            }
                            // Get Subjects and update grad plan details
                            getSchoolSubjects(false, schoolIdUpdated);

                            if($scope.gpHeader.studentGradPlanId )  $scope.getSavedNotesGP(); //SIS-832
                        }, function (error) {
                            console.info('Error in viewing student graduation plan...'.concat(angular.toJson(error)));
                            $scope.isSpinnerActive = false;

                            $scope.editGradErrorOccurred = true;
                            $scope.editErrorMesg = "";
                            if (error.status == 400) {
                                $scope.stuGradPlanSuccess = false;
                                for (var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }
                        })

                    } else {
                        //console.info("Redirecting to ");
                        $location.url('/loginError');
                    }

                };

                var getSchoolSubjects = function (flag, schoolId) {
                    //GET subject list for school
                    var getSubjectsBySchoolPromise = graduationPlanSvc.getSubjectsBySchool(authentication.getCurrentUser().keycode, schoolId, flag);
                    getSubjectsBySchoolPromise.then(function (data) {
                        console.info("Providing list of related subject");
                        $scope.subjectMap = utilService.schoolSubjectMap(data.schoolSubjectList);
                        $scope.courseMap = utilService.schoolCourseMap(data.schoolSubjectList);
                        $scope.subjectFields = data.schoolSubjectList.sort(function(a, b) {
                            return a.name > b.name ? 1 : -1;
                        });
                        $scope.isSpinnerActive = false;

                        //invoke and render student grad plan details
                        getStudentGradPlanDetails();
                    }, function (error) {
                        console.info('Error in getting subjectlist....'.concat(angular.toJson(error)));
                        $scope.stuGradPlanSuccess = false;
                        $scope.isSpinnerActive = false;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.editErrorMesg = $scope.editErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.editErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.editErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }
                    })

                };


                $scope.LCStudentChanged = false;
                $scope.changeLCStudent = function(selectedLCStu){
                    console.log("changed", selectedLCStu);
                    $scope.LCStudentChanged = true;
                    $scope.changedLCStu = selectedLCStu;
                    if($scope.LCStudentChanged){
                        getStudentGradPlan(selectedLCStu.id, authentication.getCurrentUser().schoolId);
                        $rootScope.getStudentGradPlanBySubject(selectedLCStu.id);
                    }
                }

                var getStudentGradPlanDetails = function () {
                    $scope.yearPlans = [];
                    $scope.yearDetailList = $scope.yearDetailList.sort(function (a, b) {
                        return a.schoolYear > b.schoolYear ? 1 : -1;
                    });

                    angular.forEach($scope.yearDetailList, function (yearDetails, index1) {
                        //reference yearPlans values
                        $scope.yearPlans.push({
                            yearName: '',
                            index: index1,
                            terms: []
                        });

                        $scope.yearPlans[index1].yearName = yearDetails.yearName;
                        $scope.yearPlans[index1].schoolYear = "(" + yearDetails.schoolYear + " - " + (yearDetails.schoolYear + 1) + ")";
                        $scope.yearPlans[index1].schoolYearNum = yearDetails.schoolYear;
                        $scope.yearPlans[index1].stuPlanYearId = yearDetails.yearId;
                        $scope.yearPlans[index1].open = true;

                        $scope.yearPlans[index1].totalCreditsEarned = yearDetails.totalCreditsEarned;
                        $scope.yearPlans[index1].totalCreditsInProgress = yearDetails.totalCreditsInProgress;
                        $scope.yearPlans[index1].totalCreditsNotStarted = yearDetails.totalCreditsNotStarted;
                        $scope.yearPlans[index1].totalCreditsDoNotIncludeTowardDiploma = yearDetails.totalCreditsDoNotIncludeTowardDiploma;

                        //sort terms based on sequence
                        yearDetails.stdDbGplanTermList = yearDetails.stdDbGplanTermList.sort(function (a, b) {
                            if (angular.isUndefined(a.sequence))
                                return -1;
                            if (angular.isUndefined(b.sequence))
                                return 1;
                            return a.sequence > b.sequence ? 1 : -1;
                        });

                        $scope.yearPlans[index1].additionalTerms = {
                            courses: []
                        };
                        angular.forEach(yearDetails.stdDbGplanTermList, function (term, index2) {

                            //additional terms with no terms info
                            if (angular.isUndefined(term.termId)) {
                                angular.forEach(term.stDbGplanCourseList, function (course, index3) {
                                    $scope.yearPlans[index1].additionalTerms.courses.push({});
                                    var length = $scope.yearPlans[index1].additionalTerms.courses.length;
                                    initialiseYearPlanCourse($scope.yearPlans[index1].additionalTerms.courses[length - 1], course);
                                });

                                $scope.yearPlans[index1].additionalTerms.courses.sort(sortSubjectCourse);
                            }
                            //normal terms with terms info
                            else {
                                $scope.yearPlans[index1].terms.push({
                                    termName: term.termName,
                                    termId: term.termId,
                                    courses: [],
                                    sequence: parseInt(term.sequence)
                                });
                                var length = $scope.yearPlans[index1].terms.length;

                                angular.forEach(term.stDbGplanCourseList, function (course, index3) {
                                    $scope.yearPlans[index1].terms[length - 1].courses.push({});
                                    initialiseYearPlanCourse($scope.yearPlans[index1].terms[length - 1].courses[index3], course);
                                });

                                $scope.yearPlans[index1].terms[length - 1].courses.sort(sortSubjectCourse);
                            }
                        });
                    });

                    // create yearPlanSnapShot with index, status
                    for (var i = 0; i < $scope.yearPlans.length; i++) {
                        $scope.yearPlans[i].index = i;
                        $scope.yearPlans[i].status = 1;
                        if (angular.isDefined($scope.yearPlans[i].terms)) {
                            for (var j = 0; j < $scope.yearPlans[i].terms.length; j++) {
                                $scope.yearPlans[i].terms[j].index = j;
                                $scope.yearPlans[i].terms[j].status = 1;
                                for (var k = 0; k < $scope.yearPlans[i].terms[j].courses.length; k++) {
                                    $scope.yearPlans[i].terms[j].courses[k].index = k;
                                    $scope.yearPlans[i].terms[j].courses[k].status = 1;
                                }
                            }
                        }
                        for (var j = 0; j < $scope.yearPlans[i].additionalTerms.courses.length; j++) {
                            $scope.yearPlans[i].additionalTerms.courses[j].index = j;
                            $scope.yearPlans[i].additionalTerms.courses[j].status = 1;
                        }
                    }

                    $scope.additionalCourseList = [];
                    angular.forEach($scope.addCoursesList.stdDbGplanTermList, function (termList, index1) {
                        var res = {};
                        angular.forEach(termList.stDbGplanCourseList, function (stuGPCourse, index2) {
                            res.index = index2;
                            res.termId = termList.termId;
                            res.termName = termList.termName;
                            res.subjectName = $scope.subjectNameFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId);
                            res.subject = subjectFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId);
                            res.courseName = $scope.courseDisplay(stuGPCourse);
                            res.course = courseFromMap(stuGPCourse.schoolSubjectId, stuGPCourse.k12SubjectId, stuGPCourse.courseId);
                            res.courseId = stuGPCourse.courseId;
                            if (angular.isDefined(stuGPCourse.schoolYear)) {
                                res.schoolYear = stuGPCourse.schoolYear + " - " + (stuGPCourse.schoolYear + 1);
                            } else {
                                res.schoolYear = angular.isDefined(stuGPCourse.additnlCousDisplaySchoolYear) ? (stuGPCourse.additnlCousDisplaySchoolYear + " - " + (stuGPCourse.additnlCousDisplaySchoolYear + 1)) : "";
                            }
                            res.grade = stuGPCourse.gradeMark;
                            res.completionStatusId = stuGPCourse.completionStatusId;
                            res.credits = $scope.creditsDisplay(stuGPCourse);
                            res.dualCredit = stuGPCourse.dualCredit;
                            res.tranTermType = stuGPCourse.tranTermType;
                            res.showDagger = stuGPCourse.doNotIncludeInCreditTotals == 1 || stuGPCourse.subjectNotOnDiploma == 1 ? true : false;
                            res.showAstrick = stuGPCourse.completionStatusId == 0 || stuGPCourse.completionStatusId == 1 ? true : false;
                            res.coursechecked = stuGPCourse.coursechecked;
                            //SIS-405 . Set donotIncludeInCreditTotals flag for courses in additional courses
                            res.doNotIncludeInCreditTotals = stuGPCourse.doNotIncludeInCreditTotals;
                            res.subjectNotOnDiploma = stuGPCourse.subjectNotOnDiploma;
                            res.id = stuGPCourse.id;

                            // SIS -303 amd 314 -- If subject is changed in additional course list and saved,
                            // When you come back to additional courses section, on new edit course object is not assigned
                            // as it now belongs to different subject
                            //If course id in retrieved listis defined and not null then assgn that course object
                            var selectedCourse = res.course;
                            if (selectedCourse != null && angular.isUndefined(selectedCourse.id)) {
                                if (angular.isDefined(res.courseId) && res.courseId != null) {
                                    selectedCourse = {
                                        id: res.courseId,
                                        name: $scope.courseDisplay(stuGPCourse),
                                        credits: $scope.creditsDisplay(stuGPCourse)
                                    };
                                    res.course = selectedCourse;
                                }
                            }
                            $scope.additionalCourseList.push(res);
                        });
                        //sort
                        $scope.additionalCourseList.sort(sortSubjectCourse);

                        // create additionalCoursesSnapShot with index, status
                        for (var i = 0; i < $scope.additionalCourseList.length; i++) {
                            $scope.additionalCourseList[i].index = i;
                            $scope.additionalCourseList[i].status = 1;
                        }

                    });

                    $scope.additionalRequirementList = [];
                    if ($scope.addRequirementList != null && angular.isDefined($scope.addRequirementList)) {
                        $scope.addReqStatusMap = additionalReqStatusMap();
                        angular.forEach($scope.addRequirementList, function (addReq, index1) {
                            var res = {};
                            res.index = index1;
                            res.id = addReq.id;
                            res.category = addReq.gpARCategory;
                            res.name = addReq.name;
                            res.comments = addReq.comments;
                            res.required = (addReq.required == 0) ? "No" : "Yes";
                            res.requiredEdit = addReq.required;
                            res.completionStatus = additionalReqValueFromMap(addReq.completionStatusId);
                            $scope.additionalRequirementList.push(res);
                            //sort additional requirements in category order
                            $scope.additionalRequirementList = $scope.additionalRequirementList.sort(function (a, b) {
                                return a.category > b.category ? 1 : -1;
                            });
                        });
                    }

                const selectedPathwayEntries = [];
                const pathwaySummary = [];

                const pathwayRequirements = $scope.pathwayRequirementsList.selectedPathway.pathwayRequirements || [];
                const pathwaySummaryData = $scope.pathwayRequirementsList.pathwaysSummary;
                $scope.pathwayStatus = $scope.pathwayRequirementsList.selectedPathway.completionStatusId;
                $scope.pathwayName = $scope.pathwayRequirementsList.selectedPathway.name;

                pathwayRequirements.forEach(requirement => selectedPathwayEntries.push(...requirement.requiredCourses));
                pathwaySummaryData.forEach(pathway => pathwaySummary.push(pathway));

                $scope.pathwayEntries = angular.copy(selectedPathwayEntries);
                $scope.pathwaySummary = angular.copy(pathwaySummary);
                $scope.hasCRETrackingSchoolAccess = $scope.pathwayRequirementsList.isCreTrackingOn;
                $scope.pathwayRequirements = angular.copy(pathwayRequirements);

                $scope.getGradeClass = function(pathwayEntry) {
                    if (pathwayEntry.courseOverride || pathwayEntry.completionStatusId == 3) {
                        return 'bgGreen'
                    } else if (pathwayEntry.completionStatusId == 1) {
                        return 'bgGrey'
                    } else if (pathwayEntry.completionStatusId == 2) {
                        return 'bgBlue'
                    } else if (pathwayEntry.completionStatusId == 4) {
                        return 'bgRed'
                    }
                    }

                $scope.calcRows = function(course) {
                    const pathwayRequirements = $scope.pathwayRequirementsList.selectedPathway.pathwayRequirements || [];
                    const currentRequirement = pathwayRequirements.find(requirement => requirement.requiredCourses.find(item => item.id === course.id));
                    if (currentRequirement.requiredCourses.length && currentRequirement.requiredCourses[0].id === course.id) {
                        return currentRequirement.requiredCourses.length;
                    } else {
                        return 0;
                    }
                }

                $scope.cellIsHidden = function(course) {
                    const rows = $scope.calcRows(course);
                    return rows === 0;
                }

                $scope.getPathwayStatusText = function(course) {
                    const pathwayRequirements = $scope.pathwayRequirementsList.selectedPathway.pathwayRequirements || [];
                    const selectedRequirement = pathwayRequirements.find(requirement => requirement.requiredCourses.find(item => item.id === course.id));
                    const status_list = [];

                    if (selectedRequirement.requiredCourses.some(item => item.courseOverride))
                        return "Completed"

                    selectedRequirement.requiredCourses.forEach(({completionStatusId}) => status_list.push(completionStatusId));

                    if (status_list.includes('3'))
                        return "Completed"

                    if (status_list.includes('2'))
                        return "In Progress"

                    if (status_list.includes('1'))
                        return "Not Started"

                    if (status_list.includes('4'))
                        return "Failed"

                    return "Outstanding";
                    }

                $scope.getNotes = function(course){
                    let notes = "";
                    const pathwayRequirements = $scope.pathwayRequirementsList.selectedPathway.pathwayRequirements || [];
                    const currentRequirement = pathwayRequirements.find(requirement => requirement.requiredCourses.find(item => item.id === course.id));
                    const override = currentRequirement.requiredCourses.find(course => course.courseOverride);

                    if (override) {
                        notes = `Fulfilled by ${override.courseOverride.courseName}`
                    } else {
                        const rows = $scope.calcRows(course);
                        if (rows > 1) {
                        notes = "Either course fulfills\n this requirement.";
                        }
                    }
                    return notes;
                    }

                };

                $scope.getGrade = (pathwayEntry)=>{
                  let grade = pathwayEntry.grade;
                  if (pathwayEntry.courseOverride)
                    grade = pathwayEntry.courseOverride.grade
                  return grade;
                }

                var initialiseYearPlanCourse = function (courseObj, course) {
                    courseObj.id = course.id;
                    courseObj.courseName = $scope.courseDisplay(course);
                    courseObj.course = courseFromMap(course.schoolSubjectId, course.k12SubjectId, course.courseId);
                    courseObj.subjectName = $scope.subjectNameFromMap(course.schoolSubjectId, course.k12SubjectId);
                    courseObj.subject = subjectFromMap(course.schoolSubjectId, course.k12SubjectId);
                    courseObj.completionStatusId = course.completionStatusId;
                    courseObj.grade = course.gradeMark;
                    courseObj.credits = $scope.creditsDisplay(course);
                    courseObj.creditsEarned = course.creditsEarned;
                    courseObj.dualCredit = course.dualCredit;
                    courseObj.tranTermType = course.tranTermType;
                    courseObj.showDagger =
                        course.doNotIncludeInCreditTotals == 1 || course.subjectNotOnDiploma == 1 ? true : false;
                    courseObj.showAstrick =
                        course.completionStatusId == 0 || course.completionStatusId == 1 ? true : false;
                    courseObj.doNotIncludeInCreditTotals = course.doNotIncludeInCreditTotals;
                    courseObj.subjectNotOnDiploma = course.subjectNotOnDiploma;
                    courseObj.coursechecked = course.coursechecked;

                    var preCourse = courseObj.course;
                    if (angular.isUndefined(courseObj.allcourses)) {
                        courseObj.allcourses = [];
                        if (angular.isDefined(courseObj.subject.courses))
                            angular.extend(courseObj.allcourses,
                                courseObj.subject.courses);
                    }
                    if (preCourse != null && angular.isUndefined(preCourse.id) && $scope.courseDisplay(course) != "Not Specified" && angular.isDefined(courseObj.allcourses)) {
                        preCourse = {
                            id: course.courseId,
                            name: $scope.courseDisplay(course),
                            credits: $scope.creditsDisplay(course)
                        };
                        courseObj.allcourses.push(preCourse);
                        courseObj.course = preCourse;

                    }
                };

                $scope.subjectNameFromMap = function (schoolSubjectId, k12SubjectId) {
                    var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId" + schoolSubjectId : null;
                    var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId" + k12SubjectId : null;
                    var subjectName = "";
                    if (angular.isDefined( $scope.subjectMap[schSubjectId])) {
                        subjectName = $scope.subjectMap[schSubjectId].name;
                    }
                    if (angular.isDefined($scope.subjectMap[k12SubjectId])) {
                        subjectName = $scope.subjectMap[k12SubjectId].name;
                    }
                    return subjectName;
                };

                var subjectFromMap = function (schoolSubjectId, k12SubjectId) {
                    var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId" + schoolSubjectId : null;
                    var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId" + k12SubjectId : null;
                    var subject = {};
                    if (angular.isDefined($scope.subjectMap[schSubjectId])) {
                        subject = $scope.subjectMap[schSubjectId];
                    }
                    if (angular.isDefined($scope.subjectMap[k12SubjectId])) {
                        subject = $scope.subjectMap[k12SubjectId];
                    }
                    return subject;
                };

                var courseFromMap = function (schoolSubjectId, k12SubjectId, courseId) {
                    var schSubjectId = angular.isDefined(schoolSubjectId) ? "schSubjectId" + schoolSubjectId : "";
                    var k12SubjectId = angular.isDefined(k12SubjectId) ? "k12SubjectId" + k12SubjectId : "";
                    var courseId = angular.isDefined(courseId) ? "courseId" + courseId : "";
                    var course = {};

                    if (angular.isDefined($scope.courseMap[schSubjectId + courseId])) {
                        course = $scope.courseMap[schSubjectId + courseId];
                    }
                    if (angular.isDefined($scope.courseMap[k12SubjectId + courseId])) {
                        course = $scope.courseMap[k12SubjectId + courseId];
                    }
                    return course;
                };
                $scope.courseDisplay= function (course) {
                    var courseText = "";
                    if ((course.completionStatusId == 3 || course.completionStatusId == 4) && angular.isDefined(course.tranCourseName)) {
                        courseText = course.tranCourseName;
                    } else if (course.isNonK12Course == 1) {
                         courseText = angular.isDefined(course.nonK12CourseName) ? course.nonK12CourseName : "Not Specified";
                    } else {
                        courseText = angular.isDefined(course.courseName) ? course.courseName : "Not Specified";
                    }
                    return courseText;
                };
                $scope.creditsDisplay = function (course) {
                    var creditText = "";
                    if (course.completionStatusId == 3 || course.completionStatusId == 4) {
                        creditText = course.creditsEarned;
                    } else {
                        creditText = course.credits;
                    }
                    return creditText;
                };
                var calculateProgressBar = function (creditsEarned, creditsRequired) {
                    var percentCompleted = ((creditsEarned / creditsRequired) * 100).toFixed(0);
                    if (isNaN(percentCompleted) || (percentCompleted < 1)) {
                        return 0;
                    } else if (percentCompleted > 100) {
                        return 100;
                    } else {
                        return percentCompleted;
                    }
                };

                //sorting logic for subject&course list
                var sortSubjectCourse = function (a, b) {
                    if ((a.subjectName == "" || b.subjectName == "") && !(a.subjectName == "" && b.subjectName == "")) {
                        if (a.subjectName == "")
                            return 1;
                        else
                            return -1;
                    }
                    if (a.subjectName == b.subjectName) {
                        if (a.courseName == "Not Specified" || b.courseName == "Not Specified") {
                            if (a.courseName == "Not Specified") return 1;
                            else return -1;
                        } else {
                            return a.courseName > b.courseName ? 1 : -1;
                        }
                    }
                    if (a.subjectName > b.subjectName) {
                        return 1;
                    }
                    if (a.subjectName < b.subjectName) {
                        return -1;
                    }
                };

                var additionalReqStatusMap = function () {
                    return [{
                        id: 0,
                        label: 'Not Started'
                    }, {
                        id: 1,
                        label: 'In Progress'
                    }, {
                        id: 2,
                        label: 'Completed'
                    }];
                };
                var additionalReqValueFromMap = function (key) {
                    return (angular.isDefined($scope.addReqStatusMap[key])) ? $scope.addReqStatusMap[key] : 0;
                };

                if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
                	if(authentication.hasStudentRole()){
                		getStudentGradPlan(authentication.getCurrentUser().studentId, authentication.getCurrentUser().schoolId);
                    }
                	else if(authentication.hasLCRole()){
                        getStudentsLCList(authentication.getCurrentUser().personId, authentication.getCurrentUser().schoolId);
                		//call BE Service to get list of LC Students --
                        $timeout(function () {
                            getStudentGradPlan($scope.selStuId, authentication.getCurrentUser().schoolId);
                        }, 500)
                    }
                } else {
                    $timeout(function () {
                        console.info("Keycode not found. Waiting 500 ms")
                        getStudentGradPlan(authentication.getCurrentUser().studentId, authentication.getCurrentUser().schoolId);
                    }, 500)
                };


          }
        ]);

}(angular, schoolwork12));
